import * as Yup from "yup";
var timeString = Yup.string().trim();
var activitySchema = Yup.object({
    id: Yup.string().required(),
    time: timeString.required("Activity time is required"),
    title: Yup.string().required("Activity title is required"),
    location: Yup.string().required("Activity location is required"),
    description: Yup.string().required("Activity description is required"),
});
var daySchema = Yup.object({
    id: Yup.string().required(),
    day: Yup.string().required(),
    title: Yup.string().required("Day title is required"),
    description: Yup.string().required("Day description is required"),
    activities: Yup.array()
        .of(activitySchema)
        .min(1, "At least one activity required")
        .required(),
});
var step1Schema = Yup.object({
    tripTitle: Yup.string().required("Trip title is required"),
    source: Yup.string().required("Source is required"),
    destination: Yup.string().required("Destination is required"),
    startDate: Yup.mixed().required("Start date is required"),
    endDate: Yup.mixed().required("End date is required"),
    tripCategories: Yup.array().min(1, "Select at least one category").required(),
});
var step2Schema = Yup.object({
    coverImage: Yup.mixed().required("A cover image is mandatory"),
    description: Yup.string().required("Description is required"),
});
var step3Schema = Yup.object({
    privacy: Yup.string().required("Privacy selection is required"),
    allowJoinRequests: Yup.boolean().required(),
    maxParticipants: Yup.number().min(1, "At least 1 participant").required(),
});
var step4Schema = Yup.object({
    /* logistics: Yup.object({
      accommodation: Yup.object({
        hotelName: Yup.string().required("Hotel name required"),
        address: Yup.string().required("Address required"),
      }).required(),
      transport: Yup.object({
        number: Yup.string().required("Transport number required"),
      }).required(),
    }).required(), */
    itinerary: Yup.array()
        .of(daySchema)
        .min(1, "At least one day is required")
        .required(),
    modeOfTransport: Yup.string().required("Mode of transport is required"),
    meetingTime: Yup.string().required("Meeting time is required"),
    meetingPoint: Yup.string().required("Meeting point is required"),
});
var step5Schema = Yup.object({});
export var getSchemaForStep = function (step) {
    switch (step) {
        case 1:
            return step1Schema;
        case 2:
            return step2Schema;
        case 3:
            return step3Schema;
        case 4:
            return step4Schema;
        case 5:
            return step5Schema;
        default:
            return Yup.object();
    }
};
export default getSchemaForStep;
